var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      attrs: { flat: "" },
      on: {
        click: function($event) {
          return _vm.showCalendar()
        }
      }
    },
    [
      _c("div", { staticClass: "flex-container" }, [
        _c(
          "div",
          { staticClass: "icon-container" },
          [_c("v-icon", [_vm._v("calendar_today")])],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "date-container" }, [
          _c("p", [_vm._v(_vm._s(this.formatDate().startDate) + " ")]),
          _vm._v(" "),
          this.formatDate().endDate
            ? _c("p", [_vm._v(" - " + _vm._s(this.formatDate().endDate))])
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26837f1d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26837f1d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DateRangePicker.vue
// module id = null
// module chunks = 